import React, { useState } from 'react';

import './administration.css'
import { Box, Tab, Tabs } from '@mui/material';
import Devices from './administrationTabs/devices';
import Schedules from './administrationTabs/schedules';
import Geofences from './administrationTabs/geofences';
import { TabPanel } from '../../utils/generalFunctions';

const Administration = ({ devices, userGeoTag, userRoute, geoTags, geofences, userSchedules, userUpdate, scheduleRegister, deleteSchedule, updateSchedule, showAlert }) => {
    const [value, setValue] = useState(0); // Índice de la pestaña seleccionada

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <section className="administration_container" style={{overflowY: 'hidden'}}>
            <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', gap: '0.5rem', overflowY: 'hidden' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleTabChange} aria-label="Administration tabs">
                        <Tab label="Dispositivos" sx={{
                            color: 'var(--color-dark)', // Color para pestañas inactivas
                            '&.Mui-selected': { color: 'var(--color-primary)' },
                            fontSize: '0.7rem',
                        }} />
                        <Tab label="Horarios" sx={{
                            color: 'var(--color-dark)', // Color para pestañas inactivas
                            '&.Mui-selected': { color: 'var(--color-primary)' },
                            fontSize: '0.7rem'
                        }} />
                        <Tab label="Puntos de control" sx={{
                            color: 'var(--color-dark)', // Color para pestañas inactivas
                            '&.Mui-selected': { color: 'var(--color-primary)' },
                            fontSize: '0.7rem'
                        }} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0} className='tab_panel' >
                    <Devices devices={devices} userSchedules={userSchedules} userUpdate={userUpdate} updateSchedule={updateSchedule} />
                </TabPanel>
                <TabPanel value={value} index={1} className='tab_panel'>
                    <Schedules
                        devices={devices}
                        userRoute={userRoute}
                        geoTags={geoTags}
                        geofences={geofences}
                        userSchedules={userSchedules}
                        userUpdate={userUpdate}
                        updateSchedule={updateSchedule}
                        scheduleRegister={scheduleRegister}
                        deleteSchedule={deleteSchedule}
                        showAlert={showAlert}
                    />
                </TabPanel>
                <TabPanel value={value} index={2} className='tab_panel'>
                    <Geofences geoTags={geoTags} geofences={geofences} userRoute={userRoute} userUpdate={userUpdate} />
                </TabPanel>
            </div>
        </section>
    );
};

export default Administration;
